import axios from 'axios'
import { push } from 'connected-react-router'
import { store } from 'services/configureStore'
import endpoints from 'services/endpoints'
import { showErrorMessage } from 'services/handleErrors'
import moment from 'moment'
import _ from 'lodash'

import { GET_NOTIFICATIONS_SUCCESS, SET_NOTIFICATION_READ } from './actionTypes'

const processUnreadGoalReports = (notices, dispatch) => {
  let unreadReportsCount = 0;

  for (let i = 0; notices.length > i; i += 1) {
    const notice = notices[i]

    if (notice.referenceType === 'GoalReport' && notice.state === 'new') {
      unreadReportsCount += 1
      dispatch(push(`/goal-report?goalId=${notice.referenceId}&notificationId=${notice.id}`))

      break;
    }
  }

  const { settings, user } = store.getState()
  const isGoalNotSet = user.currentGoal === null
  const goToGoalSetting = settings.goalSettingSkip.indexOf(`${user.login}_${moment().format('MM.YYYY')}`) === -1

  if (isGoalNotSet && goToGoalSetting && unreadReportsCount < 1) {
    dispatch(push('/create-goal?step=set-goal'))
  }

  return null
}

export const getUserNotices = () => dispatch => {
  return axios
    .post(endpoints.getUserNotices, { limit: 10 })
    .then(res => {
      const notices = _.get(res, 'data.notices', [])
      const unread = _.get(res, 'data.newNoticeCount', 0)
      const { router } = store.getState();

      if (['/goal-report', '/create-goal', '/verification', '/login'].indexOf(router.location.pathname) === -1) {
        processUnreadGoalReports(notices, dispatch)
      }

      dispatch({
        type: GET_NOTIFICATIONS_SUCCESS,
        list: notices,
        unread
      })
    })
    .catch(err => {
      showErrorMessage(err)
    })
}

export const readNotice = id => dispatch => {
  axios
  .post(endpoints.readNotice, { id })
  .then(() => {
    dispatch({
      type: SET_NOTIFICATION_READ, id
    })
  })
  .catch(err => showErrorMessage(err))
}
